const CalculatorTypeEnum = {
    PROTECTION: "Protection",
    RETIREMENT: "Retirement"
}

export default CalculatorTypeEnum;

